
import { AsistenteEnLineaUtils } from './utils/asistente-en-linea.utils';
import { HandlerType } from './models/HandlerType';
import { Contexto } from './models/contexto';
import { ConciergeService } from './services/concierge.service';
import { Component, OnInit, OnDestroy, AfterContentInit, Renderer2, Inject, Output, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { VentanaUtils } from './utils/ventana.utils';
import { LocalStorageService } from './services/local-storage.service';
import { alissMensajes } from './components/asistencia-chat/utils/aliss-mensajes';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
import { FormElements } from './models/FormElements';
import { AsistenciaMenuComponent } from './components/asistencia-menu/asistencia-menu.component';
import { NodeType } from './components/asistencia-menu-arbol/models/node-type';
import { PopupService } from './services/popup.service';
import { RecaptchaService } from './services/recaptcha.service';
import { ContextoUrlService } from './services/contexto-url.service';
import { NavigationContextService } from './services/navigation-context.service';

@Component({
  selector: 'app-asistente-en-linea',
  templateUrl: './asistente-en-linea.component.html',
  styleUrls: ['./asistente-en-linea.component.scss']
})
export class AsistenteEnLineaComponent implements OnInit, AfterContentInit, OnDestroy {
  @Output("loadMantenedor") loadMantenedor = new EventEmitter();
  @ViewChild(AsistenciaMenuComponent, { static: false }) asistenciaMenuComponent: AsistenciaMenuComponent;

  subscriptionHand: Subscription;

  subscriptionClose: Subscription;
  sub: Subscription;
  initHandler: boolean;
  handlerType: HandlerType = new HandlerType();
  formElements: FormElements = new FormElements();
  ctx: Contexto = new Contexto();
  primeraCarga = false;
  renderChat = false;
  renderEmail = false;
  renderTramite = false;
  // botonera que permite seleccionar el tipo de atencion (chat o email)
  renderMenu = true;
  renderMenuArbol = false;
  menuHabilitado = false;
  /**
   * Constructor del componente
   */
  constructor(public conciergeService: ConciergeService,
    private route: ActivatedRoute,
    private utils: AsistenteEnLineaUtils,
    private window: VentanaUtils,
    private recaptchaSrv: RecaptchaService,
    public dialog: MatDialog,
    private popupService: PopupService,
    private contextoService:ContextoUrlService,
    private localstorage: LocalStorageService,
    private navigationContextService: NavigationContextService,
    private _render2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private router: Router
  ) {

  }

  /**
   * Inicializacion del componente
   */
   async ngOnInit(): Promise<void> {
    // Hay que comentar seccion del dominio para que funcione localhost

    // se agrega dominio = bps.gub.uy para evitar errores de permiso al integrar con portal
    const script = this._render2.createElement('script');
    script.type = 'text/javascript';
    script.text = `document.domain=\"${environment.domain}\"; `;
    // Se agrega el script al header
    this._render2.appendChild(this._document.body, script);

    this.initHandler = false;

    const params = await this.route.queryParamMap.pipe( filter(p => p.keys.length > 0),take(1) ) .toPromise();
  

      // Se hace verdadero al finalizar ngAfterContentInit, asi evitar consumir el servicio sin los query params
      if (this.initHandler) {
        if (params.get("config") === "menuAdmin") {
          //this.sub.unsubscribe();
          this.router.navigate(['/config/home/']);

          this.loadMantenedor.emit();
        }
        else {
          if (params.get("idServicio") || params.get("idNodo")) {
            // Obtenemos los parametros con los que instanciaron al componente
            this.navigationContextService.clearAll();
            this.ctx = this.utils.obtenerParametrosPortal(this.ctx, params);
            const idsParam = params.get('ids');
            if (idsParam) {
              const idsArray = idsParam.split(',');
              this.navigationContextService.addNodes(idsArray);
            }

            await this.askForHandlerAsincrono(this.ctx);
          // this.askForHandlerSync(this.ctx, false) ;
            // La presencia del ID de servicio del local storage indica que hay una conversacion activa
            // se valida que se esté entrando al mismo servicio (restriccion: solo un chat activo a la vez)
            console.log('asistente-en-linea.ngOnInit():: this.localstorage.getServiceID(): %s / this.ctx.idServicio: %s / this.ctx.codAsistente: %s', this.localstorage.getServiceID(), this.ctx.idServicio, this.ctx.codAsistente);

            //Si hay participantId es porque hay conversación entonces no quiero mostrar el icono
            // sino abrir el mismo chat
            /* if (this.localstorage.getHandlerType() === 'chat'
              && this.localstorage.getServiceID() === this.ctx.idServicio) {*/
            const participantID: string = this.localstorage.getParticipantID();
            //if (participantID && participantID.length > 0 && this.localstorage.getServiceID() === this.ctx.idServicio) {
            if (participantID && participantID.length > 0 && this.localstorage.getAsistenteID() === this.ctx.codAsistente) {
              // El ID de servicio en el localstorage solo existe cuando hay un chat activo
              // si retorno al mismo servicio despliego el CHAT, de lo contrario se despliega el menu
              this.renderComponent(this.utils.renderChat);
            } /*else if (this.localstorage.getHandlerType() === 'email') {
              this.renderComponent(this.utils.renderEmail);
            }
            else if (this.localstorage.getHandlerType() === 'menuArbol') {
              this.renderComponent(this.utils.renderMenuArbol);
            } else {
              this.renderComponent(this.utils.renderMenu);
            }**/

          }
        }
      };
  }

  ngAfterContentInit() {
    this.initHandler = true;
    // Subscripcion del evento de cierre de ventana
    this.subscriptionClose = this.window.close.subscribe((msg) => {
      if(this.ctx.idNodo!='desdeChat') {
        const participantID: string = this.localstorage.getParticipantID();
        if (participantID && participantID.length > 0) {
          // Si es un chat y estoy cerrando el chat del servicio que generó el participantId (para multiples pestañas)
          //if (this.handlerType.chat && this.localstorage.getServiceID() === this.ctx.idServicio) {
          //if (this.localstorage.getHandlerType() === 'chat' && this.localstorage.getServiceID() === this.ctx.idServicio) {
          if (this.localstorage.getHandlerType() === 'chat' && this.ctx.codAsistente && this.localstorage.getAsistenteID() === this.ctx.codAsistente.toString()) {
            const dialogRef = this.dialog.open(ConfirmModalComponent,
              { data: { message: alissMensajes.confirmacionCierre, btnOK: 'SI', btnNOK: 'NO' }, panelClass: 'custom-modalbox' });
            dialogRef.afterClosed().subscribe(result => {
              if (result && result === ConfirmModalComponent.OK) {
                // Se limplia el localstorage
                this.localstorage.cleanStorage();

                this.renderComponent(this.utils.renderMenu);
                // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
                this.window.setDefaultIframeSize();

                // Chequeo para mostrar le feedback al dar Ok en finalizar la comunicación sólo si hay una 
                // conversación con un asesor. Si el usuario se encuentra en cola y acepta finalizar la comunicación
                // no muestra el feedback.
                if (this.ctx.interactionInfo.agentName) {
                  this.abrirEncuesta(this.ctx.codAsistente,this.ctx.idNodo);
                }
              }
            });
            // No es un chat entonces no limpia el localstorage para mantener el chat en el otro servicio 
          } else {
            this.ctx.idMenu = this.ctx.historialMenus[0];
            if (this.ctx.idMenu) {
              this.ctx.idAsistente = this.ctx.idMenu ? Number(this.ctx.idMenu) : null;
              this.ctx.historialMenus = [this.ctx.idMenu];
            } else {
              this.ctx.historialMenus =  this.ctx.idAsistente != undefined ? [this.ctx.idAsistente.toString()] : [];
            }
            //this.ctx.idNodo=undefined;
            // No necesita confirmacion y cierra
            this.renderComponent(this.utils.renderMenu);
            // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
            this.window.setDefaultIframeSize();
          }
        } else {
          // Se limplia el localstorage
          this.localstorage.cleanStorage();
          this.ctx.idMenu = this.ctx.historialMenus[0];
          if (this.ctx.idMenu) {
            this.ctx.idAsistente = this.ctx.idMenu ? Number(this.ctx.idMenu) : null;
            this.ctx.historialMenus = [this.ctx.idMenu];
          } else {
            this.ctx.historialMenus = this.ctx.idAsistente != undefined ? [this.ctx.idAsistente.toString()] : [];
          }

          //this.ctx.idNodo=undefined;
          // Chequea si hubo un participantId y un agente asigando para mostrar o no el PUF.
          // Se cubre el caso de mostrar el feedback cuando hubo una comunicación atendida por un asesor
          // y no mostarlo cuando solo se abre y cierra, cuando está cerrado o cuando está en cola de espera o
          // directamente no hay lugar en cola ya que no hay un agente asignado.
          // En el caso de timeout muestra el feedback si se corta por inactividad y si retoma y queda en cola
          // o si no hay lugar en cola dado que realiza la encuesta sobre la comunicación que se cerró por inactividad.
          // Si retoma con otro asesor, el feedback sería sobre la nueva comunicación.
          if (this.ctx.interactionInfo.participantId && this.ctx.interactionInfo.agentName) {
            this.abrirEncuesta(this.ctx.codAsistente,this.ctx.idNodo);
          }

          // Chat no activo no necesita confirmacion y cierra
          this.renderComponent(this.utils.renderMenu);
          // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
          this.window.setDefaultIframeSize();

        }
      } else {
        this.ctx.idNodo = undefined;
        this.emitSwitchHandlerEmitter(undefined);
      }

      if (this.ctx.hideAfterClose) {
        this.window.eliminiarVentana();
      }
      this.recaptchaSrv.limpiarRecaptchaV3();

    });
  }

  /**
   * Abre la encuesta siempre que exista un codigo asociado al ID de servicio
   * @param codAsistente ID del asistente
   */
  abrirEncuesta(codAsistente: string, idNodo: string) {
    
    console.log("Buscando Codigo de encuesta para: %s", codAsistente);
    if(this.ctx.destinatarioChat.requiereEncuesta && this.ctx.destinatarioChat.codigoEncuesta != undefined && this.ctx.destinatarioChat.codigoEncuesta != '') {
      const encuestaFunction = 'ejecutarAbrirEncuesta';
      const ejecutarAbrirEncuesta = parent[encuestaFunction];
      ejecutarAbrirEncuesta(this.ctx.destinatarioChat.codigoEncuesta, [''], {});
    } else {
      console.log("No hay codigo de encuesta para ID servicio: %s", this.ctx.codAsistente);
    }

   /** this.conciergeService.getCodigoEncuesta(codAsistente,idNodo).pipe(take(1)).subscribe((respuesta) => {
      console.log(">>> Resultado:: JSON.stringify(respuesta) %s", JSON.stringify(respuesta));

      if (respuesta && respuesta.codigo) {
        console.log("Codigo de Encuesta: %s", respuesta.codigo);
        ejecutarAbrirEncuesta(respuesta.codigo, [''], {});
      } else {
        console.log("No hay codigo de encuesta para ID servicio: %s", this.ctx.codAsistente);
      }

    });**/
  }

  ngOnDestroy() {
    this.subscriptionClose.unsubscribe();
  }

  abrirVentanaCentrada() {
    let url = this.ctx.urlSitioAutenticar + '/?';
    if (this.ctx.idServicio) {
      url = url + "&idServicio=" + this.ctx.idServicio;
    }
    if (this.ctx.idNodo) {
      url = url + "&idNodo=" + this.ctx.idNodo;
    }
    url = url + "&open=true&hideAllButtonsForm=true&goInside=true&fromAnonymous=true";

    const ids = this.navigationContextService.getIds();
    if(ids && ids.length > 0) {
      url = url + "&ids=" + this.navigationContextService.getIds();
    }
    
    url = url + "&contexto=" + this.contextoService.encode(this.contextoService.getParentUrlSafely());
    this.popupService.abrirVentana(url, "Alisse", 600, 750);
  }

  askForHandler(ctx) {
    this.subscriptionHand = this.conciergeService.askForHandler(ctx).pipe(take(1)).subscribe((response) => {
      this.ctx.esEntornoAnonimo = response.esEntornoAnonimo;
      this.ctx.urlSitioAutenticar = response.urlSitioAutenticar;
      this.ctx.modificarDatosUrl = response.modificarDatosUrl;
      this.ctx.clavePublicaV2 = response.clavePublicaV2;
      this.ctx.clavePublicaV3 = response.clavePublicaV3;

     // this.ctx.esEntornoAnonimo=true;
      //this.ctx.urlSitioAutenticar='http://localhost:4200/';
      
      this.ctx.habilitado = response.habilitado;    
      this.ctx.urlSitioBps = response.urlSitioBps;
      this.ctx.requiereAutenticacion = response.requiereAutenticacion;
      // Ask for Handler retorna informacion respecto del HandlerType y un mensaje de bienvenida
      // se hace llegar este msg. de bienvenida al comp. asistencia-chat
      if (response.handlerType === 'chat' || response.handlerType === 'both') {
        this.ctx.interactionInfo.welcomeMsg = response.interactionInfo.welcomeMsg;
        this.localstorage.setWelcomeMsg(response.interactionInfo.welcomeMsg);
      }
      if (response.handlerType === 'email' && response.esFormulario && ctx.idNodo) {
        ctx.codigoTema = response.codigoTema;
      }
      this.ctx.tipoFormulario = response.tipoFormulario;

      // El ask for hander deja el nombre del servicio en el contexto
      this.ctx.descServicio = response.descServicio;

      //se carga idMenu
      this.ctx.idMenu = response.idMenu;
      this.ctx.historialMenus = response.historialMenus;
      this.ctx.idFormAsociado = response.idFormAsociado;
      this.ctx.idAsistente = response.idAsistente;
      if (response.formElements) {
        this.ctx.formElements.datosEmpresa = response.formElements.datosEmpresa;
        this.ctx.formElements.datosObra = response.formElements.datosObra;
      }
      this.utils.evaluateConcergeResponse(this.handlerType, this.formElements, response);
      if (this.ctx.open) {
        //this.ctx.esEntornoAnonimo=true;
        let compToRender = [false, false, false, true, false];
        if (response.handlerType === 'chat') {
          compToRender = [true, false, false, false, false];
        } else if (response.handlerType === 'tramite') {
          compToRender = [false, false, false, false, true];
        } else if (response.handlerType === 'form' || response.handlerType === 'email') {
          compToRender = [false, true, false, false, false];
        }/** else {
            compToRender = [false, false, false, true,false];
          }**/

        this.renderComponent(compToRender);
      }
    });
  }

  async askForHandlerAsincrono(ctx): Promise<void> {
    try {
      this.ctx.errorCarga = false;
      this.ctx.mensajeErrorCarga=undefined;
      const response = await this.conciergeService
        .askForHandler(ctx)
        .pipe(take(1))
        .toPromise();

        this.ctx.errorCarga = response.errorCarga;
        this.ctx.mensajeErrorCarga = response.mensajeErrorCarga;
        this.ctx.evitarValidarSesionPortal = response.evitarValidarSesionPortal;

        if(this.ctx.errorCarga) {
          if(this.ctx.mensajeErrorCarga==undefined) {
            this.ctx.mensajeErrorCarga = "En este momento no podemos atenderlo debido a que estamos experimentando algunos problemas técnicos; por favor intente comunicarse con nosotros más tarde.";
          }
          response.handlerType='menuArbol';
          this.utils.evaluateConcergeResponse(this.handlerType, this.formElements, response);
        } else {
          this.ctx.esEntornoAnonimo = response.esEntornoAnonimo;
          this.ctx.urlSitioAutenticar = response.urlSitioAutenticar;
          this.ctx.clavePublicaV2 = response.clavePublicaV2;
          this.ctx.clavePublicaV3 = response.clavePublicaV3;
          this.ctx.captchaHabilitado = response.captchaHabilitado;

          //this.ctx.esEntornoAnonimo=true;
          //this.ctx.urlSitioAutenticar='http://localhost:4200/';
          
          this.ctx.habilitado = response.habilitado;    
          this.ctx.urlSitioBps = response.urlSitioBps;
          this.ctx.modificarDatosUrl = response.modificarDatosUrl;
          this.ctx.requiereAutenticacion = response.requiereAutenticacion;
          // Ask for Handler retorna informacion respecto del HandlerType y un mensaje de bienvenida
          // se hace llegar este msg. de bienvenida al comp. asistencia-chat
          if (response.handlerType === 'chat' || response.handlerType === 'both') {
            this.ctx.interactionInfo.welcomeMsg = response.interactionInfo.welcomeMsg;
            this.localstorage.setWelcomeMsg(response.interactionInfo.welcomeMsg);
          }
          if (response.handlerType === 'email' && response.esFormulario && ctx.idNodo) {
            ctx.codigoTema = response.codigoTema;
          }
          this.ctx.tipoFormulario = response.tipoFormulario;

          // El ask for hander deja el nombre del servicio en el contexto
          this.ctx.descServicio = response.descServicio;

          //se carga idMenu
          this.ctx.idMenu = response.idMenu;
          this.ctx.historialMenus = response.historialMenus;
          this.ctx.idFormAsociado = response.idFormAsociado;
          this.ctx.idAsistente = response.idAsistente;
          if (response.formElements) {
            this.ctx.formElements.datosEmpresa = response.formElements.datosEmpresa;
            this.ctx.formElements.datosObra = response.formElements.datosObra;
          }
          this.utils.evaluateConcergeResponse(this.handlerType, this.formElements, response);
          if (this.ctx.open) {
            //this.ctx.esEntornoAnonimo=true;
            let compToRender = [false, false, false, true, false];
            if (response.handlerType === 'chat') {
              compToRender = [true, false, false, false, false];
            } else if (response.handlerType === 'tramite') {
              compToRender = [false, false, false, false, true];
            } else if (response.handlerType === 'form' || response.handlerType === 'email') {
              compToRender = [false, true, false, false, false];
            }/** else {
                compToRender = [false, false, false, true,false];
              }**/
            if (this.ctx.esEntornoAnonimo && this.ctx.requiereAutenticacion) {
                this.abrirVentanaCentrada();
            } else {
              this.renderComponent(compToRender);
            }
          }
        }
      } catch (error: any) {
        this.ctx.errorCarga = true;
        console.error('Error al llamar askForHandler', error);
      
        if (error.status === 500) {
          this.ctx.mensajeErrorCarga=error.error?.statusMessage;
        }

        if(this.ctx.mensajeErrorCarga==undefined) {
          this.ctx.mensajeErrorCarga = "En este momento no podemos atenderlo debido a que estamos experimentando algunos problemas técnicos; por favor intente comunicarse con nosotros más tarde.";
        }
        let compToRender = [false, false, false, true, false];
        this.renderComponent(compToRender);
      }
  }

  /*
  Se retorna el handler necesario (uno de los renders de utils) para poder renderizar el componente que corresponde al
  id actual del contexto.
  */
  async askForHandlerSync(ctx, esEmail) {
    this.localstorage.removeIdMenuAccion();
    this.localstorage.removeHandlerAccionType();
    return this.conciergeService.askForHandler(ctx).toPromise().then((response: any) => {
      this.ctx.habilitado = response.habilitado;
      this.ctx.interactionInfo.welcomeMsg = response.interactionInfo.welcomeMsg;
      if (esEmail) {
        response.handlerType = "email";
      }
      this.ctx.evitarValidarSesionPortal = response.evitarValidarSesionPortal;
      this.ctx.clavePublicaV2 = response.clavePublicaV2;
      this.ctx.clavePublicaV3 = response.clavePublicaV3;
      this.ctx.tipoFormulario = response.tipoFormulario;
      this.ctx.esEntornoAnonimo = response.esEntornoAnonimo;
      this.ctx.captchaHabilitado = response.captchaHabilitado;
      this.ctx.urlSitioAutenticar = response.urlSitioAutenticar;
      this.ctx.urlSitioBps = response.urlSitioBps;
      this.ctx.modificarDatosUrl = response.modificarDatosUrl;
      this.localstorage.setWelcomeMsg(response.interactionInfo.welcomeMsg);

      this.ctx.descServicio = response.descServicio;
      this.localstorage.setIdMenuAccion(response.idMenu);
      this.localstorage.setHandlerAccionType(response.handlerType);
      this.ctx.historialMenus = response.historialMenus;
      if (response.handlerType === 'chat') {
        return this.utils.renderChat;
      } else if (response.handlerType === 'email') {
        this.formElements.datosEmpresa = response.formElements.datosEmpresa;
        this.formElements.datosObra = response.formElements.datosObra;
        return this.utils.renderEmail;
      } else if (response.handlerType === 'menuArbol') {
        this.ctx.idMenu = response.idMenu;
        return this.utils.renderMenuArbol;
      }
      return this.utils.renderMenu;
    })
  }

  renderComponent(component: boolean[]) {
    //this.ctx.esEntornoAnonimo=false;
    //this.ctx.requiereAutenticacion = true;
    //this.ctx.esEntornoAnonimo = true;

    if (this.ctx.esEntornoAnonimo && this.ctx.requiereAutenticacion) {
      this.abrirVentanaCentrada();
    } else {
      this.renderChat = component[0];
      this.renderEmail = component[1];
      this.renderMenu = component[2];
      this.renderMenuArbol = component[3];
      this.renderTramite = component[4];

      /*console.log('AsistenteEnLineaComponent.renderComponent():: component: %s / renderChat: %s / renderEmail: %s / renderMenu: %s / renderMenuArbol: %s / formElements.datosEmrpesa: %s / formElements.datosObra: %s',
        component, this.renderChat, this.renderEmail, this.renderMenu, this.renderMenuArbol, this.formElements.datosEmpresa, this.formElements.datosObra);*/

      if (this.renderEmail) {
        this.window.emailComponentStyle();
        this.localstorage.setHandlerType('email');
      } else if (this.renderChat) {
        this.window.chatComponentStyle();
        this.localstorage.setHandlerType('chat');
      } else if (this.renderMenuArbol) {
        this.window.menuArbolComponentStyle();
        this.localstorage.setHandlerType('menuArbol');
      } else if (this.renderTramite) {
        this.window.menuArbolComponentStyle();
        this.localstorage.setHandlerType('tramite');
      } else {
        // Si no es email o chat asume icono de asistencia (menu)
        // El refresh y ctl+F5 provocan la ejecucion de este metodo
        this.window.setDefaultIframeSize();
      }
    }

  }

  async emitRenderMenuArbol(event) {
    //console.log("IDS",this.navigationContextService.getIds());
    if(event.codAsistenteError) {
      this.ctx.codAsistenteError=event.codAsistenteError;
    }

    this.ctx.esReporteError = event.esReporteError ? true:false;
    this.ctx.idServicio = event.idServicio;
    this.ctx.codAsistente = event.codAsistente;
    this.ctx.codigoTema = event.codigoTema;
    if (event.tipo == NodeType.Chat || event.tipo == NodeType.Form || event.tipo == NodeType.Tramite) {
      let compToRender = [false, false, false, false, false];
      this.ctx.codigoNodoArbol = event.nodo.id;
      this.ctx.idNodo = event.nodo.id;
      this.ctx.etiquetaTema = event.nodo.temaMotivo

      if (event.tipo == NodeType.Chat) {
        compToRender = [true, false, false, false, false];
      }
      if (event.tipo == NodeType.Tramite) {
        compToRender = [false, false, false, false, true];
      }
      if (event.tipo == NodeType.Form) {
        compToRender = [false, true, false, false, false];
        this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
        this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
        this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
        this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;

        if ("0" == event.nodo.tipoFormulario) {
          this.ctx.tipoFormulario = "Persona";
        } else {
          this.ctx.tipoFormulario = "Empresa";
        }
      }
      //this.ctx.esEntornoAnonimo=true;
      if (this.ctx.esEntornoAnonimo && event.nodo && event.nodo.requiereAutenticacion) {
        this.navigationContextService.addNode(event.nodo.id);
        this.abrirVentanaCentrada();
      } else {
        this.renderComponent(compToRender)
      }
    } else {
      // let ctxNew = this.ctx;
      // ctxNew.idNodo=undefined;
      if (event.tipo == NodeType.Action) {
        this.navigationContextService.addNode(event.nodo.id);
        this.ctx.idNodo = event.nodo.id;
        //ctxNew.idNodo = event.nodo.id;
      }

      let compToRender = await this.askForHandlerSync(this.ctx, event.esEmail || false);
      this.renderComponent(compToRender)
    }
   // console.log("IDS",this.navigationContextService.getIds());
    event.done();
  }

  /**
   * Metodo utilizado para hacer switch de handler (desde formulario hacia menu-arbol)
   * @param event
   */
  async emitSwitchHandlerEmitter(event) {
    this.ctx.esFormulario = event && event.esFormulario || false;
    if (this.ctx.esFormulario) {
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
    }
    if(event) {
      this.ctx.idServicio = event.idServicio;
      this.ctx.codAsistente = event.codAsistente;
      this.ctx.codigoTema = event.codigoTema;
      this.ctx.idMenu = event.idMenu;
      this.ctx.idFormAsociado = event.idFormAsociado;
    }

    let compToRender = await this.askForHandlerSync(this.ctx,  false);
    this.renderComponent(compToRender)
  }

  async emitChangeContextDataEmitter(event) {
    this.ctx.esFormulario = event.esFormulario || false;
    if (this.ctx.esFormulario) {
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
    }
    this.ctx.idServicio = event.idServicio;
    this.ctx.codAsistente = event.codAsistente;
    this.ctx.codigoTema = event.codigoTema;
    this.ctx.idMenu = event.idMenu;
    this.ctx.idFormAsociado = event.idFormAsociado;

  }

  public loadScript({ id, url }) {
    return new Promise((resolve, reject) => {
      let script = this._render2.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = '';
      script.src = url;
      script.id = id;
      script.onload = () => {
        resolve({ id: id, loaded: true, status: 'Loaded' });
      };
      script.onerror = (error: any) => resolve({ id: id, loaded: false, status: 'Loaded' });
      script.async = true;
      script.defer = true;
      this._render2.appendChild(this._document.body, script);
    });
  }

  @HostListener('document:ejecutarAccionMessageChannel', ['$event'])
  //se debe mantener en esta ubicación para que funcione correctamente
  handleEjecutarAccion(event: CustomEvent) {
    this.resolverAccionChannelMessaging(event);
  }

  resolverAccionChannelMessaging(event: CustomEvent) {
    //debugger
    var accion = event.detail.accion;
    if (accion == 'desplegar-aliss') {
      this.desplegarAliss();
    }
  }

  async desplegarAliss() {
    var tipoAsistente = '';

    if (this.handlerType.chat) {
      tipoAsistente = 'chat';
    }
    else if (this.handlerType.email) {
      tipoAsistente = 'email'
    }
    else if (this.handlerType.menuArbol) {
      tipoAsistente = 'menuArbol'
    }
    if (tipoAsistente) {
      this.asistenciaMenuComponent.onClickRenderComponent(tipoAsistente)
    }
  }
}
